import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col, Input, Button, Spin } from 'antd';
import { Modal } from 'antd-mobile';
import IdleTimer from 'react-idle-timer';
import { withTranslation } from 'react-i18next';

const { TextArea } = Input;
const confirmAlert = Modal.alert;

@inject(
    'templateStore',
    'bookingSummaryStore',
    'loginStore',
    'TransactionStore',
    'webSettingStore'
)
@observer
class BookingDetailModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
        this.idleTimer = null;
    }

    componentDidMount() {
    }

    // ON CLICK

    close = () => {
        this.props.bookingSummaryStore.setShowBookingDetailModal(false);
    }

    book = () => {
        this.props.bookingSummaryStore.setbookingDetailLoading(true);
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            } else {
                const { activeTemplate } = this.props.templateStore;

                const {
                    data: webSettting
                } = this.props.webSettingStore;

                const request = this.props.bookingSummaryStore.getOrderRequest();
                this.props.TransactionStore.create(request).then(resp => {
                    if (resp.success) {

                        this.props.bookingSummaryStore.addBookingTransaction().then(response => {
                            if (response.isSuccess) {
                                confirmAlert(
                                    <div
                                        style={{
                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                            color: activeTemplate.templateSetting.label.color,
                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                        }}
                                    >
                                        <span>{webSettting.orderPopupTitleText}</span>
                                    </div>,
                                    <div
                                        style={{
                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                            color: activeTemplate.templateSetting.text.color,
                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
                                            textAlign: 'center'
                                        }}
                                    >
                                        <span>{webSettting.orderPopupSuccessText}</span>
                                    </div>,
                                    [
                                        {
                                            text:
                                                <span
                                                    style={{
                                                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                        color: activeTemplate.templateSetting.label.color,
                                                        fontSize: activeTemplate.templateSetting.label.fontSize,
                                                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                                    }}
                                                >
                                                    {webSettting.backToHomeText}
                                                </span>,
                                            onPress: () => {
                                                this.props.history.push('/');
                                            }
                                        },
                                        {
                                            text:
                                                <span
                                                    style={{
                                                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                        color: activeTemplate.templateSetting.label.color,
                                                        fontSize: activeTemplate.templateSetting.label.fontSize,
                                                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                                    }}
                                                >
                                                    {webSettting.goToOrderText}
                                                </span>,
                                            onPress: () => {
                                                this.props.history.push('/order');
                                            }
                                        }
                                    ]);
                            } else {
                                confirmAlert('Booking Failed', <div>{response.error}</div>, [
                                    {
                                        text: 'OK', onPress: () => {
                                            this.props.history.push('/booking');
                                        }
                                    }
                                ]);
                            }
                        });
                    } else {
                        confirmAlert(
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                <span>Error</span>
                            </div>,
                            <div
                                style={{
                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                    color: activeTemplate.templateSetting.text.color,
                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
                                    textAlign: 'center'
                                }}
                            >
                                <span>{webSettting.orderPopupFailedText}</span>
                            </div>,
                            [
                                {
                                    text:
                                        <span
                                            style={{
                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                color: activeTemplate.templateSetting.label.color,
                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                            }}
                                        >
                                            OK
                                        </span>
                                }
                            ]);
                    }
                });
            }
        });
    }

    // Idle Timer

    handleOnIdle = () => {
        const { activeTemplate } = this.props.templateStore;
        const { data: webSettting } = this.props.webSettingStore;

        this.props.bookingSummaryStore.setShowBookingDetailModal(false);
        confirmAlert(
            <div style={{
                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                color: activeTemplate.templateSetting.label.color,
                fontSize: activeTemplate.templateSetting.label.fontSize,
                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
            }}>
                <span>Info</span>
            </div>,
            <div style={{
                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                color: activeTemplate.templateSetting.text.color,
                fontSize: activeTemplate.templateSetting.text.fontSize,
                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
            }}>There was no activity for a while. Please refresh the page.</div>, [
            {
                text: 
                    <span style={{
                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                        color: activeTemplate.templateSetting.label.color,
                        fontSize: activeTemplate.templateSetting.label.fontSize,
                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                    }}>{webSettting.okText}</span>
                , onPress: () => {
                    window.location.reload(true);
                }
            }
        ]);
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            bookingDetail,
            bookingDateText,
            bookingDetailLoading
        } = this.props.bookingSummaryStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 60 * 3} onIdle={this.handleOnIdle} debounce={250} />

                                        {/* Booking Detail */}
                                        <>
                                            {
                                                bookingDetail === null
                                                    ?
                                                    null
                                                    :
                                                    <Spin spinning={bookingDetailLoading}>
                                                        <Row>
                                                            <Col
                                                                span={18}
                                                                className='stm-padding-top-24 stm-padding-left-16 stm-margin-bottom-16'
                                                                style={{
                                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                    color: activeTemplate.templateSetting.label.color,
                                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                }}
                                                            >
                                                                <span>{webSettting.confirmYourBookingText}</span>
                                                            </Col>
                                                            <Col span={6} className='stm-margin-bottom-12 stm-text-align-center'>
                                                                <img
                                                                    className='stm-modal-image-close'
                                                                    src={require('../../assets/image/CloseModal.svg')}
                                                                    alt='closemodal'
                                                                    onClick={this.close} />
                                                            </Col>
                                                            <Col
                                                                span={24}
                                                                className='stm-padding-left-16 stm-padding-right-16  stm-margin-bottom-8'
                                                                style={{
                                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                    color: activeTemplate.templateSetting.label.color,
                                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                }}
                                                            >
                                                                <span>{bookingDetail.bookingCategoryName}</span>
                                                            </Col>
                                                            <>
                                                                {
                                                                    bookingDetail.bookingSubCategoryName !== null
                                                                        ?
                                                                        <Col
                                                                            span={24}
                                                                            className='stm-padding-left-16 stm-padding-right-16  stm-margin-bottom-8'
                                                                            style={{
                                                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                color: activeTemplate.templateSetting.label.color,
                                                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                            }}
                                                                        >
                                                                            <span>{bookingDetail.bookingSubCategoryName}</span>
                                                                        </Col>
                                                                        :
                                                                        null
                                                                }
                                                            </>
                                                            <Col
                                                                span={24}
                                                                className='stm-padding-left-16 stm-padding-right-16 stm-margin-bottom-16'
                                                                style={{
                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                    color: activeTemplate.templateSetting.text.color,
                                                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                                                                }}
                                                            >
                                                                <span>{webSettting.bookingDateText}: {bookingDateText}</span><br />
                                                                <span>{webSettting.bookingTimeText}: {`${bookingDetail.startTime} - ${bookingDetail.endTime}`}</span><br />
                                                            </Col>
                                                            <Col
                                                                span={24}
                                                                className='stm-padding-left-16 stm-padding-right-16'
                                                            >
                                                                <TextArea
                                                                    rows={3}
                                                                    value={bookingDetail.remark}
                                                                    onChange={(e) => this.props.bookingSummaryStore.setBookingDetailRemark(e.target.value)}
                                                                    placeholder={webSettting.remarkText}
                                                                    style={{
                                                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                        color: activeTemplate.templateSetting.text.color,
                                                                        fontSize: activeTemplate.templateSetting.text.fontSize
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col
                                                                span={24}
                                                                className='stm-padding-left-16 stm-padding-right-16 stm-margin-top-16 stm-margin-bottom-16'
                                                            >
                                                                <Button
                                                                    className='stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2'
                                                                    onClick={this.book}
                                                                    style={{
                                                                        background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                                        fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                                        fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                                        lineHeight: `${activeTemplate.templateSetting.buttonFooter.fontSize + 2}px`,
                                                                        color: activeTemplate.templateSetting.buttonFooter.color
                                                                    }}
                                                                >{webSettting.bookNowText}</Button>
                                                            </Col>
                                                        </Row>
                                                    </Spin>
                                            }
                                        </>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(BookingDetailModal)
